import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, doc, setDoc, updateDoc} from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default function escribirLog_agregar_producto_empaque(accion, usuario, valor_cantidad_ingresado,nombreproducto,Presentacion, date, orden_compra) {
  console.log(accion, usuario, valor_cantidad_ingresado, nombreproducto);
  var persona= usuario.email;
  if(orden_compra == undefined){
    orden_compra = "";
  }else{persona= "Se genero desde la orden de compra con folio "+orden_compra}

  const cosecha= "NA";
  const retirado= "NA";
  //let date = new Date();
  let fecha_actual = String(date.getDate()).padStart(2, '0') + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + date.getFullYear() ;
  let hora_actual=  date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

  const collectionRef = collection(db, "Almacen_empaque/LOGS/LOGS".replace(/ /g, ""));
  const docuRef = doc(collectionRef, new Date().toString());
  const data = {
    accion,
    fecha: fecha_actual,
    fecha3: date,
    Hora: hora_actual,
    Autor: persona,
    Seccion: Presentacion,
    Cantidad_retirada: retirado,
    Cantidad_agregada: valor_cantidad_ingresado,
    Producto_retirado: nombreproducto,
    Titulo: new Date().toString(),
    Cosecha: cosecha,
    Orden_folio: orden_compra,
  };

  setDoc(docuRef, data)
  //setDoc(docuRef, data);
}
